import Icon from './IconBase.js'

const EditIcon = (props) => (
    <Icon
        width="15"
        height="15"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9 15H15.75"
            stroke="#00B0F5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.375 2.62499C12.6734 2.32662 13.078 2.159 13.5 2.159C13.7089 2.159 13.9158 2.20015 14.1088 2.2801C14.3019 2.36006 14.4773 2.47725 14.625 2.62499C14.7727 2.77272 14.8899 2.94811 14.9699 3.14114C15.0498 3.33417 15.091 3.54105 15.091 3.74999C15.091 3.95892 15.0498 4.1658 14.9699 4.35883C14.8899 4.55186 14.7727 4.72725 14.625 4.87499L5.25 14.25L2.25 15L3 12L12.375 2.62499Z"
            stroke="#00B0F5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
)

export default EditIcon
